export default __webpack_public_path__ + "static/media/7minfitness_13@2x.effd08eb.jpg";